// extracted by mini-css-extract-plugin
export var artdirected = "image-art-direction-module--artdirected--d6965";
export var imageWithCaption = "image-art-direction-module--imageWithCaption--37238";
export var zoom = "image-art-direction-module--zoom--6184d";